const tiposDeMoedas = [
	{"linguagem": "pt-BR", "estilo":"currency", "pais": "BRL"},
	{"linguagem": "en-US", "estilo":"currency", "pais": "USD"}, 
	{"linguagem": "en-au", "estilo":"currency", "pais": "AUD"},
	{"linguagem": "en-ca", "estilo":"currency", "pais": "CAD"},
	{"linguagem": "ja", "estilo":"currency", "pais": "JPY"},
	{"linguagem": "fr", "estilo":"currency", "pais": "EUR"},
	{"linguagem": "en-gb", "estilo":"currency", "pais": "GBP"},
	{"linguagem": "zh-sg", "estilo":"currency", "pais": "SGD"},
	{"linguagem": "es-mx", "estilo":"currency", "pais": "MXN"},
];

const selecionarMoeda = (pais) => {
	let moedaSelecionada = [];
	tiposDeMoedas.map(item => {
		//Verifica se o codigo do pais existe
		if(item.pais === pais){
			//Adcionar as informações das moedas dentro do array
			moedaSelecionada.push(item);
		}
	});

	if(pais === undefined){
		const [moedas] = tiposDeMoedas;
		moedaSelecionada.push(moedas);
	}
	return moedaSelecionada;
}

/**
 * Função para formatação de moeda do tipo BRL
 * @param {String} novoValor
 */
const formatarMoedaBRL = (novoValor) => {
	const RetirarPonto = novoValor.replace(/\./g, "");
	const valorBRLFormatado = RetirarPonto.replace(",", ".");
	return valorBRLFormatado;
}

/**
 * Funçã para formatação de moeda do tipo EUR
 * @param {String} novoValor: 
 */
const formatarMoedaEUR = (novoValor) => {
	novoValor = novoValor.replace(/\s/g, "");
	const valorEURFormatado = novoValor.replace(",", ".");
	return valorEURFormatado;
}

//array para armazenar todos os códigos das moedas
const codigoMoeda = ["￥", "€", "$", "£", "R$", "S$", "Mex$"];

/** Função para formatar o tipo da moeda de um pais esepcifico
 * @param {String} valor: Um valor a ser formatado.
 * @param {String} tipoDeMoeda: De qual pais a moeda va ser formatada.
 */
const localizarTipoDeMoeda = (valor, tipoDeMoeda) => {
	let novoValor = valor; 
	
	if(typeof(valor) === "string"){
		codigoMoeda.map(codigo => {
			const sigla = valor.indexOf(codigo);
			if(sigla !== -1){
				novoValor = valor.replace(codigo, "");
			}
		});
		
		if(tipoDeMoeda === "BRL") {
			const valorBRL = formatarMoedaBRL(novoValor);
			return valorBRL;
		}
		else if(tipoDeMoeda === "EUR"){
			const valorEUR = formatarMoedaEUR(novoValor);
			return valorEUR;
		}else{
			return novoValor.replace(/\,/g, "");
		}
	}
	return valor
}

export default {

  methods: {
    converterValorStringEmNumero(valor, tipoDeMoeda) {

		const moeda = localizarTipoDeMoeda(valor, tipoDeMoeda);
		return moeda;
		
		/** CODIGO ANTIGO 
		if (typeof valor != "string") return valor;
		valor = valor.replace("R$", "").replace("$", "").replace("￥", "").replace("€", "").replace("£", "").replace("S$", "").replace("Mex$", "")
		valor = valor.replace('\r', ''); //Remove o pulo de linha caso vem de importação.
		if (tipoDeMoeda.indexOf("BRL") != -1) {
			valor = valor.replace(/\./g, "");
			valor = valor.replace(",", ".");
		} else if (tipoDeMoeda.indexOf("EUR") != -1) {
			valor = valor.replace(/\s/g, "");
			valor = valor.replace(",", ".")
		} else {
			valor = valor.replace(/\,/g, "");
		}
		if (isNaN(valor)) {
			valor = 0
			return valor;
		}
		**/
	},

    converterParaMoedaReal(numero, tipoDeMoeda) {
		let formatter;
		const moeda = selecionarMoeda(tipoDeMoeda);
		const [{ linguagem, estilo, pais }]  = moeda;
		formatter = this.converterOutrasMoedas(linguagem, estilo, pais);
		return formatter.format(numero);
		
		/* CODIGO ANTIGO
		if (tipoDeMoeda == 'USD') formatter = this.converterOutrasMoedas('en-US', 'currency', 'USD');
		else if (tipoDeMoeda == 'AUD') formatter = this.converterOutrasMoedas('en-au', 'currency', 'AUD');
		else if (tipoDeMoeda == 'CAD') formatter = this.converterOutrasMoedas('en-ca', 'currency', 'CAD');
		else if (tipoDeMoeda == 'JPY') formatter = this.converterOutrasMoedas('ja', 'currency', 'JPY');
		else if (tipoDeMoeda == 'EUR') formatter = this.converterOutrasMoedas('fr', 'currency', 'EUR');
		else if (tipoDeMoeda == 'GBP') formatter = this.converterOutrasMoedas('en-gb', 'currency', 'GBP');
		else if (tipoDeMoeda == 'SGD') formatter = this.converterOutrasMoedas('zh-sg', 'currency', 'SGD');
		else if (tipoDeMoeda == 'MXN') formatter = this.converterOutrasMoedas('es-mx', 'currency', 'MXN');
		else formatter = this.converterOutrasMoedas('pt-BR', 'currency', 'BRL');*/
	},


    /**
     * @param {String} linguagem: A lingaguem do Pais.
     * @param {String} estilo: O tipo do estilo que vai ser aplicado na moeda.
     * @param {String} pais: A sigla do país para formatação das moedas. 
     */
    converterOutrasMoedas(linguagem, estilo, pais) {
		const formatarNumero =  new Intl.NumberFormat(linguagem, {
			style: estilo,
			currency: pais,
			minimumFractionDigits: 2
		});
		return formatarNumero;
    },
  }
}
